module.exports = __webpack_public_path__ + "static/media/fondoolas.6d354e67.webp";